import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PlanSummary } from '@fitness-force/models';
import { AuthSevices } from 'libs/api/src/lib/auth.service';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import {  BillingSummaryComponent} from '../billing-summary/billing-summary.component';

import {  PaymentStatusTimelineComponent} from '../payment-status-timeline/payment-status-timeline.component';
import { PosBillingSummaryComponent } from '../pos-billing-summary/pos-billing-summary.component';



@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PaymentStatusTimelineComponent,
    BillingSummaryComponent,
    PosBillingSummaryComponent
  ]
})
export class BillingComponent implements OnInit {

  @Input('planSummarydata') planSummary$!: Observable<PlanSummary>;
  @Input('showBilling') showbilling = false;
  @Input('showPosBilling') showPosBilling = false;
  @Input() isCartFlow:boolean=false;

  @Output() closeSidePopupMember: EventEmitter<{ hideSidebar: boolean, uuid: string | null }> = new EventEmitter();
  @Output() GoToClientSubscription: EventEmitter<boolean> = new EventEmitter();
  @Output() addToCart: EventEmitter<{type:string; object:any}> = new EventEmitter();
  @Output() clearCart: EventEmitter<void> = new EventEmitter();


  showPaidFullSidebar$: Observable<boolean> | any = false;
  showPaymentStatusSidebar$: Observable<boolean> | any = false;
  uuid!: string;
  currentUserDetails: any;
  ispayment!: boolean;

  constructor(
    private authService: AuthSevices
  ) {
    this.currentUserDetails = this.authService.decodedToken;
  }

  ngOnInit(): void {
    this.showPaidFullSidebar$ = this.showbilling;
  }

  HidePaymentSummary(evt: any) {
    this.showPaymentStatusSidebar$ = false;
    this.closeSidePopupMember.emit({ hideSidebar: false, uuid: this.uuid });
  }

  CloseBillingSummary(evt: any) {
    if (evt.clientSignupUUID) {
      this.clearCart.emit();
      this.showPaidFullSidebar$ = false;
      this.uuid = evt.clientSignupUUID;
      this.showPaymentStatusSidebar$ = true;
      if (evt.ispayment)
        this.ispayment = evt.ispayment;
    }
    else {
      this.closeSidePopupMember.emit({ hideSidebar: false, uuid: this.uuid });
    }
  }

  GoToClientDetails(event: any) {
    this.GoToClientSubscription.emit(event);
  }

  AddToCart(event: any) {
    this.showPaidFullSidebar$ = false;
    this.showPaymentStatusSidebar$ = false;
    this.addToCart.emit(event);
  }
}